export const toastRef = { current: null };